import { React, useState, useContext } from 'react';
import { AppContext } from '../../services/AppContext';
import { useTranslation } from 'react-i18next';

const TagEditor = ({ closeModal, tag }) => {
    const { t } = useTranslation();
    const { apiClient, notify } = useContext(AppContext);
    const [newTag, setNewTag] = useState({ name: tag?.name || '' });
    const updating = !!tag;

    const handleSaveTag = async () => {
        const requestBody = {
            name: newTag.name
        };

        if (updating) {
            requestBody.id = tag.id;
        }

        const result = updating
            ? await apiClient.updateTag(requestBody)
            : await apiClient.createTag(requestBody);

        if (result.hasErrors) {
            return;
        }

        closeModal(true);

        notify(
            t(`pages.tags.notifications.${updating ? 'updated' : 'created'}`),
            'success'
        );
        setNewTag({});
    };

    const handleCancel = () => {
        setNewTag({});
        closeModal(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewTag((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <h3>
                    {updating
                        ? t('pages.tags.headers.update')
                        : t('pages.tags.headers.new')}
                </h3>
                <input
                    type="text"
                    name="name"
                    placeholder={t('pages.tags.placeholders.name')}
                    value={newTag.name}
                    onChange={handleChange}
                />

                <div className="container">
                    <button className="mg-r-1 width-100p" onClick={handleSaveTag}>
                        {t('pages.tags.actions.save')}
                    </button>
                    <button className="width-100p" onClick={handleCancel}>
                        {t('pages.tags.actions.cancel')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TagEditor;